// extracted by mini-css-extract-plugin
module.exports = {"fade_catalog_wrapper":"GridGenerator_fade_catalog_wrapper__RmHh1"};